import styles from './FeaturedProducts.skeleton.module.scss';
import React from 'react';
import { clsx } from '../../../../utils/clsx';
export const FeaturedProductsSkeleton = () => (React.createElement("div", { className: clsx('skeleton bdrs:2', styles.container) }));
